import request from '@/utils/request'

export function getPermissions(data) {
  return request({
    url: '/api/app/permission',
    method: 'get',
    params: data
  })
}

export function updatePermissions(data) {
  return request({
    url: '/api/app/permission?providerName=' + data.providerName + '&providerKey=' + data.providerKey,
    method: 'put',
    data
  })
}
